// Libraries
import styled from 'styled-components'

// Components
import { Aligner, Body } from 'heeds-ds'

type Props = {
  compact?: boolean
  space?: boolean
}

export const Comment = styled(Body).attrs((props) => ({
  color: props.theme.colors.text.default,
  type: 'copy4',
}))``

export const CommentTitle = styled(Body).attrs((props) => ({
  color: props.theme.colors.text.secondary,
  margin: '0 0 16px',
  type: 'copy3',
  weight: 700,
}))``

export const Container = styled(Aligner).attrs(() => ({
  padding: '56px 32px',
}))``

export const InfoText = styled.div<Props>`
  margin-left: 16px;
`
export const SubTitle = styled(Body).attrs((props) => ({
  color: props.theme.colors.text.subdued,
  type: 'copy4',
}))``

export const Title = styled(Body).attrs((props) => ({
  color: props.theme.colors.text.secondary,
  margin: '0 0 4px',
  type: 'copy3',
  weight: 600,
}))``
